import {
  inputBaseClasses,
  inputClasses,
  outlinedInputClasses,
} from '@mui/material';

import { tokenVar } from './farben';

export const MuiOutlinedInputStyle = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      // Hoehe nur fuer Single-line-Inputs locken. Multiline-Inputs
      // (z.B. die Notizen-Felder im CC-Wizard, `<TextField multiline
      // rows={...} />`) muessen ihre Hoehe an die textarea anpassen —
      // sonst quillt der Text ueber die 44px-Border-Box hinaus und
      // rendert optisch oberhalb des sichtbaren Feldes. Verwandter
      // Effekt war bereits am MuiSelect bekannt (siehe Kommentar in
      // `theme/index.tsx:129-131`).
      [`&:not(.${inputBaseClasses.multiline})`]: {
        height: '44px',
      },
      paddingRight: '6px',
      // Design-Test 25.10.2026: Hintergrund weiss, Hairline, Fokus = Primary 1px.
      backgroundColor: tokenVar('background.paper'),
      transition: 'border-color 150ms ease',
      [`&.${inputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: tokenVar('primary.main'),
        borderWidth: 1,
      },
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: tokenVar('grey.200'),
      },
      [`& .${inputBaseClasses.input}`]: {
        fontFamily: '"Montserrat", sans-serif',
        fontSize: '16px',
        color: tokenVar('text.secondary'),
        '::placeholder': {
          color: tokenVar('text.muted'),
          opacity: 1,
        },
      },
      [`&.${inputClasses.error}`]: {
        [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: tokenVar('error.main'),
        },
        [`& .${inputBaseClasses.input}`]: {
          color: tokenVar('error.main'), // Change text color for error state
          '::placeholder': {
            color: tokenVar('error.main'), // Change placeholder color for error state if needed
            opacity: 1,
          },
        },
      },
    },
    notchedOutline: {
      borderWidth: 1,
      borderColor: tokenVar('divider'),
    },
  },
};
